<template>
  <transition name="fade">
    <div
      class="modal"
      :class="value ? 'show' : 'hide'"
      :style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex flex-row align-items-center">
            <div class="row align-items-center w-100 justify-content-start">
              <h3 class="modal-title bis flex-grow-1" v-if="enduser_id >= 0">Modification du statut de la box</h3>
              <h3 class="modal-title bis flex-grow-1" v-else>Création d'un utilisateur final</h3>
              <div v-if="row_en.en_linkello"><img class="logo-linkello" src="/images/linkello.png" /></div>
            </div>

          </div>
          <div class="modal-body">
            <div class="row modal-padding">
              <div class="col-md-12">
                
                <div class="row mt-4">
                  <div class="col-md-12">
                    <h6><span class="number-title">1</span>Informations générales</h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <m-form-select
                      label="Statut de la box"
                      v-model="row_en.en_state_box"
                      :name="$Utils.randomstring('en_state_box')"
                      :rules="[$Validation.mandatory]"
                      :items="$store.state.items_en_state_box"
                      :disabled="row_en.en_state_box === 'RETURNED'"
                      :readonly="row_en.en_state_box === 'RETURNED'"
                    ></m-form-select>
                  </div>  
                  <div class="col-md-6">
                    <m-form-date label="Date de retour" v-model="row_en.en_kit_return_date" :name="$Utils.randomstring('en_kit_return_date')"></m-form-date>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <m-form-text
                      label="Raison du retour"
                      type="text"
                      v-model="row_en.en_kit_return_reason"
                      :name="$Utils.randomstring('en_kit_return_reason')"
                    ></m-form-text>
                  </div> 
                  <div class="col-md-6">
                    <m-form-text
                      label="Tests du retour"
                      type="text"
                      v-model="row_en.en_kit_return_check"
                      :name="$Utils.randomstring('en_kit_return_reason')"
                    ></m-form-text>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <m-form-text
                      label="Etat du retour"
                      type="textarea"
                      v-model="row_en.en_kit_return_details"
                      :name="$Utils.randomstring('en_kit_return_reason')"
                    ></m-form-text>
                  </div> 

                  <div class="col-md-6">

                    <img class="img-fluid mb-3" :src="row_en.en_kit_return_image" alt="" style="max-width: 50%" />

                    <m-form-file label="Sélectionnez une image" ref="inputImageMaterial" v-model="fileSelected" @inputfile="fileJusteSelected" accept="image/*"></m-form-file>
                  </div>

                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <h6><span class="number-title">2</span>Informations techniques</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <m-form-text
                      label="Adresse Mac Wifi"
                      type="text"
                      v-model="row_en.en_box_mac_address_wifi"
                      :name="$Utils.randomstring('en_box_mac_address_wifi')"
                      :rules="[$Validation.mandatory]"
                      @keyup.delete="addColons('del_mac_address_wifi')"
                      @input="addColons('mac_address_wifi')"
                    ></m-form-text>
                    <span v-if="mac_wifi" style="color: red"
                      ><icon name="exclamation-triangle" scale="1" class="mr-2"></icon>Nombre de caractères atteint!</span
                    >
                  </div>
                  <div class="col-md-6">
                    <m-form-text
                      label="Adresse Mac Ethernet"
                      type="text"
                      @keyup.delete="addColons('del_mac_address_ethernet')"
                      @input="addColons('mac_address_ethernet')"
                      v-model="row_en.en_box_mac_address_ethernet"
                      :name="$Utils.randomstring('en_box_mac_address_ethernet')"
                    ></m-form-text>
                    <span v-if="mac_ethernet" style="color: red"
                      ><icon name="exclamation-triangle" scale="1" class="mr-2"></icon>Nombre de caractères atteint!</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex flex-row justify-content-between">
            <button type="button" class="btn btn-secondary" @click="cancelWin">Annuler</button>
            <button type="button" class="btn btn-primary btn-mouveal ml-2" @click="saveWin">Sauvegarder</button>
          </div>
        </div>
      </div>
      <m-confirm-dialog
        v-model="confirmdelete"
        text="Souhaitez-vous effacer cet utilisateur final  ?"
        title="Confirmation"
        @canceled="confirmdelete = false"
        @confirmed="deleteWin()"
      ></m-confirm-dialog>
      <m-message-dialog v-model="dialogErr" title="Erreur" :text="dialogErrTxt"></m-message-dialog>
    </div>
  </transition>
</template>

<script>
export default {
  name: "EnduserWinEdit",
  props: {
    en_id: Number,
    bo_id: Number,
    value: {
      default: false,
      type: Boolean
    },
    maFiche: Boolean,
    contactType: String
  },
  data() {
    return {
      enduser_id: -1,
      dialogErr: false,
      dialogErrTxt: "",
      confirmdelete: false,
      row_en: {},
      mac_wifi: false,
      mac_ethernet: false,
      searchContactsValue: "",
      fileSelected: { image: null, binary: null },
    };
  },
  watch: {
    value(v) {
      if (v) {
        this.enduser_id = this.en_id ? this.en_id : -1;
        this.loadEnduser();
      }
    },
    contactSelected(val) {
      if (val && !this.row_en.en_fullname) this.row_en.en_fullname = this.$options.filters.formatContactNameSimple(val, "co_invoice_");
    },
    createNewEndUser() {
      this.newEndUser();
    }
  },
  computed: {},
  created() {},
  mounted() {
    window.addEventListener("keyup", this.onKeyup);
  },
  destroyed() {
    window.removeEventListener("keyup", this.onKeyup);
  },
  methods: {
    async searchContacts(val) {
      this.searchContactsValue = `contains:${val}`;
      await this.$nextTick();
      this.$refs["search-contacts"].search_go(val);
    },
    onKeyup(e) {
      if (e.key === "Escape") {
        this.cancelWin();
      }
    },

    async loadEnduser() {
      let response = await this.$axios.get(this.$config.server_url + "/extranet/2.0/endusers/" + this.enduser_id);
      this.row_en = response.data.data;
      this.image_url = this.row_en.en_kit_return_image
      this.contactSelected = this.row_en.co_id;
    },

    async saveWin() {
      let err = [];

      if (this.row_en.en_box_mac_address_wifi.length > 1 && this.row_en.en_box_mac_address_wifi.length < 17) {
        err.push({ field: "en_box_mac_address_wifi", text: "Mauvais format de l'adresse MAC wifi" });
      }

      if (this.row_en.en_box_mac_address_ethernet.length > 1 && this.row_en.en_box_mac_address_ethernet.length < 17) {
        err.push({ field: "en_box_mac_address_ethernet", text: "Mauvais format de l'adresse MAC Ethernet" });
      }
    
      if (err.length) {

        this.dialogErrTxt = "<span class='bis'>Vous devez remplir les champs : </span><br>";

        for (let ierr = 0; ierr < err.length; ierr++) {
          const error = err[ierr];
          this.dialogErrTxt += error.text + " <br>";
        }
    
        this.dialogErr = true;
    
      } else {


        let response = await this.$axios.put(this.$config.server_url + "/extranet/2.0/endusers/boxstatus/" + this.row_en.en_id, this.row_en);

        if (response.data.err) {
          this.$store.dispatch("showDialogError", response.data.err.message);
          return;
        }
 
        let row_en = response.data.data;

        this.$emit("input", false);
        this.$emit("winEditSaved", row_en.en_id);
      }
    },
    cancelWin() {
      this.$emit("input", false);
      this.$emit("winEditCanceled");
    },

    addColons(mac) {
      if (mac === "del_mac_address_wifi") {
        this.mac_wifi = false;
        let len = this.row_en.en_box_mac_address_wifi.length - 1;
        this.row_en.en_box_mac_address_wifi = this.row_en.en_box_mac_address_wifi.slice(0, len);
      } else if (mac === "del_mac_address_ethernet") {
        this.mac_ethernet = false;
        let len = this.row_en.en_box_mac_address_ethernet.length - 1;
        this.row_en.en_box_mac_address_ethernet = this.row_en.en_box_mac_address_ethernet.slice(0, len);
      } else if (mac === "mac_address_wifi") {
        if (this.row_en.en_box_mac_address_wifi.length >= 17) {
          this.mac_wifi = true;
          this.row_en.en_box_mac_address_wifi = this.row_en.en_box_mac_address_wifi.slice(0, 17);
        } else if (this.row_en.en_box_mac_address_wifi.slice(-2).indexOf(":") === -1 && this.row_en.en_box_mac_address_wifi.length > 1) {
          this.row_en.en_box_mac_address_wifi += ":";
        }
      } else if (mac === "mac_address_ethernet") {
        if (this.row_en.en_box_mac_address_ethernet.length >= 17) {
          this.mac_ethernet = true;
          this.row_en.en_box_mac_address_ethernet = this.row_en.en_box_mac_address_ethernet.slice(0, 17);
        } else if (this.row_en.en_box_mac_address_ethernet.slice(-2).indexOf(":") === -1 && this.row_en.en_box_mac_address_ethernet.length > 1) {
          this.row_en.en_box_mac_address_ethernet += ":";
        }
      }
    },

    fileJusteSelected($event) {

      this.fileSelected.image = $event[0];

      var reader = new FileReader();

      reader.onload = async function (e) {

        let response = await this.$axios.post(this.$config.server_url + "/extranet/2.0/endusers/boxstatus_image/" + this.row_en.en_id, {
            media: e.target.result
        });

        this.row_en.en_kit_return_image = response.data.data.en_kit_return_image;

      }.bind(this);

      reader.readAsDataURL($event[0]);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../scss/styles.scss";

/* .winedit-container-header {
  width: 100%;
  justify-content: space-between;
}

.modal {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.active {
  min-width: 150px;
  input {
    width: auto;
  }
} */
.logo-linkello {
  width: 150px;
}
</style>
